import styled from 'styled-components';

export const Container = styled.div`
  min-width: 0;
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Context = styled.div`
  & > span {
    color: #fff;
  }
`;
